module.exports = __webpack_public_path__ + "static/media/itunes-music-badge.0f2a6908.svg";